// extracted by mini-css-extract-plugin
module.exports = {"comp":"SectionB2_comp__KfOLI"};